import { useMemo } from "react";
import { useRouterState } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Contract } from "@/features/onboarding/enums/Contract";
import { useTRPC } from "@/trpc";

export const useReferralCode = () => {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  const trpc = useTRPC();

  const isProviderRoute = pathname.startsWith("/provider/");

  const { data: providerUser } = useQuery({
    ...trpc.provider.getProviderUser.queryOptions(),
    enabled: isProviderRoute,
  });

  const hasReferralContract = useMemo(
    () =>
      Boolean(
        providerUser?.acceptedContracts?.some(
          (contract) => contract.name === Contract.REFERRAL_PROGRAM,
        ),
      ),
    [providerUser?.acceptedContracts],
  );

  const { data: referralCode } = useQuery(
    trpc.referrals.createLink.queryOptions(undefined, {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 2,
      enabled: isProviderRoute && hasReferralContract,
    }),
  );

  if (!isProviderRoute) {
    return null;
  }

  return hasReferralContract && referralCode ? referralCode : null;
};
